import { BUSERS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import busersTypes from '../../constants/busersTypes'
import { axios } from '../../services'

const update_buser_request = () => {
  return {
    type: busersTypes.update.request
  }
}

const update_buser_success = (response) => {
  return {
    type: busersTypes.update.success,
    payload: response.data.buser
  }
}

const update_buser_failure = (messages) => {
  return {
    type: busersTypes.update.failure,
    payload: messages
  }
}

const update_buser = (buser_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(update_buser_request())

    // Request
    axios.patch(
      formatRoute(BUSERS_ROUTES.update, {id: buser_id}),
      values
    ).then( response => {
      // success
      window.showSnackbar('success', "Connected user data has been updated")
      dispatch( update_buser_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating connected user data."]
      }
      window.showSnackbar('error', errors)
      dispatch( update_buser_failure(errors))
    })
  }

}

export {
  update_buser
}



// WEBPACK FOOTER //
// ./src/js/actions/busers/update.js